import mainCaller from './mainCaller';

// 지점별 회원앱 회원권 중지 허용(2026-11-03). 끄면 회원앱 중지만 막히고 CRM 중지·중지 해제는 그대로.
export const getAppStopSetting = (branchId, token) =>
  mainCaller(`admin/api/v1/branches/${branchId}/app-stop`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });

export const saveAppStopSetting = (branchId, enabled, token) =>
  mainCaller(`admin/api/v1/branches/${branchId}/app-stop`, 'PUT', { enabled }, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
